import * as React from "react";

import SignedOutRoute from "features/common/routing/SignedOutRoute";

import matchEndOfPath from "./matchEndOfPath";

type Props = {
  children: React.ReactElement;
  preserveInitialSignedInState: boolean;
  redirectAuthenticatedUserTo?: string;
  pathEndsWith: string;
  exact?: boolean;
};

export default function SignedOutPathEndsWithRoute({
  children,
  pathEndsWith,
  ...otherProps
}: Props) {
  return (
    <SignedOutRoute
      {...otherProps}
      // @ts-ignore
      matchPath={matchEndOfPath}
      path={pathEndsWith}
    >
      {children}
    </SignedOutRoute>
  );
}
